import React from 'react';

export default function PaywallPage() {
  const handlePayment = () => {
    const tg = window.Telegram?.WebApp;
    const paymentUrl = '#';
    if (tg?.openLink) {
      tg.openLink(paymentUrl);
    } else {
      window.open(paymentUrl, '_blank');
    }
  };

  const handleSupport = () => {
    const tg = window.Telegram?.WebApp;
    if (tg?.openTelegramLink) {
      tg.openTelegramLink('#');
    } else {
      window.open('#', '_blank');
    }
  };

  return (
    <div style={{
      minHeight: '100dvh', background: 'var(--bg-primary)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '40px 24px', textAlign: 'center',
    }}>
      {/* Lock icon */}
      <div style={{
        width: 80, height: 80, borderRadius: 20,
        background: 'var(--bg-card)', border: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 24,
      }}>
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
      </div>

      <h1 style={{
        fontSize: 22, fontWeight: 700, color: 'var(--text-primary)',
        marginBottom: 12, lineHeight: 1.3,
      }}>
        Доступ закрыт
      </h1>

      <p style={{
        fontSize: 15, color: 'var(--text-secondary)', lineHeight: 1.5,
        marginBottom: 8, maxWidth: 320,
      }}>
        Для использования Fix-Hub MD необходима активная подписка.
      </p>

      <p style={{
        fontSize: 14, color: 'var(--text-tertiary)', lineHeight: 1.5,
        marginBottom: 32, maxWidth: 320,
      }}>
        Оплатите подписку, чтобы получить доступ к объектам, событиям, библиотеке и сообществу.
      </p>

      {/* What's included */}
      <div style={{
        background: 'var(--bg-card)', borderRadius: 16,
        border: '1px solid var(--border)', padding: '20px 24px',
        marginBottom: 24, width: '100%', maxWidth: 340, textAlign: 'left',
      }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-tertiary)', marginBottom: 14, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Что входит в подписку
        </div>
        {[
          { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>, text: 'Доска объектов — находите заказы' },
          { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>, text: 'Вопросы экспертам — консультации' },
          { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>, text: 'Вебинары и семинары' },
          { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></svg>, text: 'Библиотека шаблонов и курсов' },
          { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>, text: 'Закрытый чат сообщества' },
        ].map((item, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '8px 0',
            borderTop: i > 0 ? '1px solid var(--border)' : 'none',
          }}>
            <span style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>{item.icon}</span>
            <span style={{ fontSize: 14, color: 'var(--text-primary)' }}>{item.text}</span>
          </div>
        ))}
      </div>

      {/* CTA Button */}
      <button onClick={handlePayment} style={{
        width: '100%', maxWidth: 340, background: 'var(--accent)', color: '#0D0D0D',
        border: 'none', borderRadius: 14, padding: '16px', fontSize: 16,
        fontWeight: 700, cursor: 'pointer', marginBottom: 12,
      }}>
        Оплатить подписку
      </button>

      {/* Support link */}
      <button onClick={handleSupport} style={{
        background: 'none', border: 'none', color: 'var(--text-tertiary)',
        fontSize: 13, cursor: 'pointer', padding: 8,
      }}>
        Есть вопросы? Напишите нам
      </button>
    </div>
  );
}
